enum SWRCacheKeys {
  Explorer = 'explorer',
  ExplorerWithRegions = 'explorer-with-regions',
}

export { SWRCacheKeys };
